import axios from "axios";
import { baseURL } from "./baseURL";
import Cookies from "js-cookie";
import failAlert from "./failAlert";
import successAlert from "./successAlert";

//  handle cancel request
const signalList = new Map();

export const headers = {
	headers: { 
        Authorization: `Bearer ${Cookies.get('access_token')}`, 
        'Content-Type': 'application/json' 
    }
}

export function getRequestErrorMessage(error, fallback = 'Something went wrong.') {
	const data = error?.response?.data;
	if (!data) {
		return fallback;
	}

	const fieldErrors = data.errors
		? Object.values(data.errors)
			.flat()
			.filter((message) => typeof message === 'string' && message.trim() !== '')
		: [];

	if (fieldErrors.length > 0) {
		return fieldErrors.join(' ');
	}

	return data.message || fallback;
}

export const WORKSPACE_LOCKED_ALLOWED_PATHS = [
	'/workspace/locked',
	'/switch-workspace',
	'/subscription/plan',
	'/subscription/payment',
	'/subscription/invoice',
	'/verify-email',
];

export function redirectOnWorkspaceLocked() {
	const path = window.location.pathname;
	if (WORKSPACE_LOCKED_ALLOWED_PATHS.some((allowed) => path.startsWith(allowed))) {
		return;
	}
	window.location.href = '/workspace/locked';
}

const redirectOnFailure = (error) => {
	if (axios.isCancel(error) || !error.response) {
		return;
	}
	if (error.response.status === 401) { // not logged in or deactivated user
		Cookies.remove('access_token')
		Cookies.remove('mydev_token')
		localStorage.clear()
		window.location.href = '/'
	} else if (error.response.status === 403) {
		const message = (error.response?.data?.message || '').toLowerCase();
		if (message.includes('verify your email')) {
			if (window.location.pathname !== '/verify-email') {
				location.href = '/verify-email';
			}
		}
	} else if (error.response.status === 404) { // not found
		location.href = '/404'
	} else if (error.response.status === 423) { // workspace locked (subscription expired)
		redirectOnWorkspaceLocked();
	} else if (error.response.status === 500) { // server error
		//location.href = '/500'
	}
}

export function postRequestCallback(url, data, callbackFunc, errorCallbackFunc = () => {}) {
	axios.post(`${baseURL}${url}`, data, headers)
		.then(() => {
			callbackFunc()
			successAlert("Action completed");
		})
		.catch((error) => {
			// errorCallbackFunc returns true when it already showed the error
			// itself (e.g. on a form field), so skip the generic toast.
			if (errorCallbackFunc(error) !== true) {
				failAlert(error.response?.data?.message ?? "Something went wrong");
			}
			redirectOnFailure(error)
		})
}

export function postRequest(url, callBackFunc, requestData, dispatch, mode = 'alert', options = {}) {
	return new Promise((resolve, reject) => {
		axios.post(`${baseURL}${url}`, requestData, headers)
			.then((response) => {
				dispatch(callBackFunc(response.data));
				mode === 'alert' && successAlert("Action completed");
				resolve(response.data);
			})
			.catch((error) => {
				if (mode !== 'silent') {
					failAlert(error.response?.data?.message ?? "Something went wrong");
				}
				if (error.response && !options.skipRedirect) {
					redirectOnFailure(error);
				}
				reject(error);
			});
	});
}

export function getRequest(url, callBackFunc, dispatch, options = {}) {
	const headers = {
		Authorization: `Bearer ${Cookies.get('access_token')}`
	};
	let cancelTokenSource = null;

	if (options?.signalId) {
		const prevSignal = signalList.get(options.signalId);
		if (prevSignal) {
			prevSignal.cancel('Operation canceled by the user.');
		}
		cancelTokenSource = axios.CancelToken.source();
		signalList.set(options.signalId, cancelTokenSource);
	}

	axios.get(`${baseURL}${url}`, { headers, cancelToken: cancelTokenSource?.token })
		.then(response => {
			if (options?.signalId && signalList.get(options.signalId) === cancelTokenSource) {
				signalList.delete(options.signalId);
			}

			if (response.data.data) { // backend controller must be fixed. There should not be a nested data object.
				dispatch(callBackFunc(response.data.data))
			} else if(response.data) {
				dispatch(callBackFunc(response.data))
			}else{
                dispatch(callBackFunc(response))
            }

		})
		.catch(function (error) {
			if (axios.isCancel(error)) {
				return;
			}
			if (options?.signalId && signalList.get(options.signalId) === cancelTokenSource) {
				signalList.delete(options.signalId);
			}
			redirectOnFailure(error)
		});
}

axios.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response?.status === 423) {
			redirectOnWorkspaceLocked();
		}
		return Promise.reject(error);
	}
);
